<!--
 * @创建文件时间: 2019-10-20 10:45:59
 * @Auther: lfq
 * @最后修改人: lfq
 * @最后修改时间: 2019-12-28 17:11:39
 * @联系Qq:1638245306
 * @文件介绍: 
 -->
<template>
  <el-button class="d2-mr btn-text can-hover" type="text" @click="handleClick">
    <d2-icon name="search" style="font-size: 18px;color:#fff;"/>
  </el-button>
</template>

<script>
export default {
  methods: {
    handleClick () {
      this.$emit('click')
    }
  }
}
</script>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/layout/header-aside/components/header-search/index.vue"
}
</vue-filename-injector>
